import { Spinner } from '@vst/beam';

const FullPageLoading = (): JSX.Element => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
    }}
  >
    <Spinner size="large" />
  </div>
);

export default FullPageLoading;
